module.exports = __webpack_public_path__ + "img/orcasound.f2d5d96c.png";